import type { PackBundle } from './types';

// LocalStorage cache keyed by packId+version. Bundles are typically a few
// hundred KB; one slot per pack is fine, and overwriting on version bump is
// the correct invalidation strategy.

const KEY_PREFIX = 'trivia.pack.';

function key(packId: string): string { return KEY_PREFIX + packId; }

interface CacheRecord {
  version: number;
  bundle:  PackBundle;
}

export function getCachedPack(packId: string): PackBundle | null {
  try {
    const raw = window.localStorage.getItem(key(packId));
    if (!raw) return null;
    const rec = JSON.parse(raw) as CacheRecord;
    return rec.bundle;
  } catch {
    return null;
  }
}

export function setCachedPack(bundle: PackBundle): void {
  try {
    const rec: CacheRecord = { version: bundle.version, bundle };
    window.localStorage.setItem(key(bundle.pack_id), JSON.stringify(rec));
  } catch {
    // Quota errors are non-fatal — the bundle is still in memory.
  }
}
